import firebase from 'firebase/compat/app';
import "firebase/compat/auth";
import 'firebase/compat/firestore';
import 'firebase/compat/storage';

const firebaseConfig = {
    apiKey: "AIzaSyAAUcP7aRNugGspXYLCoyYY0Ap0JYZP8sw",
    authDomain: "seekcity.firebaseapp.com",
    databaseURL: "https://seekcity.firebaseio.com",
    projectId: "seekcity",
    storageBucket: "seekcity.appspot.com",
    messagingSenderId: "165672436286",
    appId: "1:165672436286:web:b60c17477eace85efe476f",
    measurementId: "G-M4KF9VZSBV"
};

firebase.initializeApp(firebaseConfig);

export default firebase;
